import {useEffect, useRef} from "react";
import {useLocation} from "react-router-dom";

/**
 * Scrolls the window back to the top on every route (pathname) change so a new
 * page always starts at its beginning. Skips the very first render to avoid
 * fighting the browser's own scroll restoration on a hard reload / deep link.
 */
function ScrollToTop() {
    const {pathname} = useLocation();
    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }, [pathname]);

    return null;
}

export default ScrollToTop;
